import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return String(n).padStart(2, '0');
}

/** 00:17:34 countdown that automatically restarts when it reaches zero. */
export function CountdownTimer({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const boxClass = isDark ? 'bg-white/10 text-cream ring-1 ring-inset ring-white/15' : 'bg-navy text-cream';
  return <div className="flex flex-col items-center gap-2.5" data-id="element-87" data-mp="2zrnonvu7owig">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-gold-light' : 'text-navy/70'}`} data-id="element-88" data-mp="2zs6wgjq5e4ir">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="1h0t90fy4uwl6" />
        This price expires in
      </p>
      <div className="flex items-center gap-1.5 sm:gap-2" role="timer" aria-live="off" aria-label={`Offer expires in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-90" data-mp="123snwvag5zvo">
        {[{
        v: pad(hours),
        l: 'Hrs'
      }, {
        v: pad(minutes),
        l: 'Min'
      }, {
        v: pad(seconds),
        l: 'Sec'
      }].map((unit, i) => <React.Fragment key={unit.l} data-id="element-91" data-mp="1l0bsr8e7x1mf" data-mpi={i}>
            {i > 0 ? <span className={`pb-4 text-lg font-bold ${isDark ? 'text-cream/40' : 'text-navy/30'}`} data-id="element-92" data-mp="1q06gx46lzd3s">:</span> : null}
            <div className={`flex w-[62px] flex-col items-center rounded-xl px-2 py-2 sm:w-[70px] ${boxClass}`} data-id="element-93" data-mp="2dozh5cu9k747">
              <span className="font-serif text-2xl font-bold tabular-nums leading-none sm:text-3xl" data-id="element-94" data-mp="2ihirm0xnmm4s">{unit.v}</span>
              <span className="mt-1 text-[9.5px] font-semibold uppercase tracking-[0.12em] opacity-70" data-id="element-95" data-mp="2sby52xtwwje6">{unit.l}</span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}